import { render } from "./TableFormResults.vue?vue&type=template&id=0dd93aec"
import script from "./TableFormResults.vue?vue&type=script&lang=js"
export * from "./TableFormResults.vue?vue&type=script&lang=js"

import "./TableFormResults.vue?vue&type=style&index=0&id=0dd93aec&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__